<template>
  <div class="info-bar">
    <div class="info-item">
      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
      <span>{{ currentDate }}</span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'InfoBar',
  setup() {
    const currentDate = ref('')
    let dateInterval = null
    
    const updateDate = () => {
      const now = new Date()
      const dateOptions = { 
        month: 'short', 
        day: 'numeric',
        weekday: 'short'
      }
      const timeOptions = { 
        hour: '2-digit', 
        minute: '2-digit' 
      }
      
      const dateStr = now.toLocaleDateString(undefined, dateOptions)
      const timeStr = now.toLocaleTimeString(undefined, timeOptions)
      
      currentDate.value = `${dateStr} ${timeStr}`
    }
    
    onMounted(() => {
      updateDate()
      dateInterval = setInterval(updateDate, 60000)
    })
    
    onUnmounted(() => {
      if (dateInterval) {
        clearInterval(dateInterval)
      }
    })
    
    return {
      currentDate
    }
  }
}
</script>

<style scoped>
.info-bar {
  position: fixed;
  top: 20px;
  left: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 30;
  flex-wrap: wrap;
  gap: 15px;
}

.info-item {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.85rem;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.1);
  padding: 12px 20px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.info-item.loading {
  opacity: 0.6;
}

.info-item .icon {
  width: 16px;
  height: 16px;
  opacity: 0.8;
}

/* 移动端响应式 */
@media (max-width: 768px) {
  .info-bar {
    top: 15px;
    left: 15px;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
  }

  .info-item {
    font-size: 0.85rem;
    padding: 10px 16px;
    border-radius: 18px;
    min-width: 100px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .info-bar {
    top: 12px;
    left: 12px;
    gap: 8px;
  }

  .info-item {
    font-size: 0.8rem;
    padding: 8px 14px;
    border-radius: 16px;
    min-width: 90px;
  }
}

/* iOS PWA 模式适配 - 下移位置避免被status bar遮挡 */
@supports (-webkit-touch-callout: none) {
  @media (display-mode: standalone) {
    .info-bar {
      top: calc(20px + env(safe-area-inset-top));
    }
    
    @media (max-width: 768px) {
      .info-bar {
        top: calc(20px + env(safe-area-inset-top));
      }
    }
    
    @media (max-width: 480px) {
      .info-bar {
        top: calc(20px + env(safe-area-inset-top));
      }
    }
  }
}

@media (max-height: 500px) and (orientation: landscape) {
  .info-bar {
    top: 10px;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .info-item {
    font-size: 0.75rem;
    padding: 6px 12px;
  }
}
</style>